/**
 * An assistant's answer, drawn as plain text and as nothing else (bata-platform epic 719
 * boundary 4, ADR 9080).
 *
 * The answer is written by a model from text a person typed, so it is untrusted: a markdown link
 * is a way to send a person somewhere, a markdown image is a request the browser makes by itself
 * (a remote image carries whatever the answer was told to put in its address), and an HTML
 * fragment is script. So there is no renderer here — the string is a child of a `<p>`, React
 * escapes it, and `white-space: pre-wrap` keeps the line breaks the answer was written with.
 * `[a](http://x)` and `![a](http://x)` and `<script>` are therefore drawn as the characters they
 * are: nothing is clickable, nothing is fetched, nothing runs.
 *
 * No `dangerouslySetInnerHTML`, no markdown library, no URL-to-link pass. Do not add one: that is
 * the whole of the safety, and `optima.test.tsx` fails on the day any of them appears.
 */

import { plainText } from './optima';

export interface AnswerTextProps {
  readonly text: string;
}

export function AnswerText({ text }: AnswerTextProps): React.JSX.Element {
  return (
    // `break-words`: a long address or identifier in the answer wraps inside the panel instead of
    // widening it. `select-text`: an answer is meant to be copied from.
    <p data-optima-answer="" className="text-body text-ink-primary whitespace-pre-wrap break-words select-text">
      {plainText(text)}
    </p>
  );
}
